import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import feathersClient from '../feathers-client';

Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'login',
        component: require("../components/Login").default
    },
    {
        path: '/fonts',
        component: require("../components/Fonts").default,
        meta: { restrictRoles: ["admin"] }
    },
    {
        path: '/icons',
        component: require("../components/Icons").default,
        meta: { restrictRoles: ["admin"] }
    },
    {
        path: '/compositions',
        component: require("../components/Compositions").default,
        meta: { restrictRoles: ["admin"] }
    },
    {
        path: '/compositions/:compositionId',
        component: require("../components/Composition").default,
        meta: { restrictRoles: ["admin"] }
    },
    {
        path: '/users',
        component: require("../components/Users").default,
        meta: { restrictRoles: ["admin"] }
    },
    {
        path: '/articles',
        component: require("../components/Articles").default,
        meta: { restrictRoles: ["admin"] }
    },
    {
        path: '/translations',
        component: require("../components/Translations").default,
        meta: { restrictRoles: ["admin"] }
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
})

router.beforeEach(async  (to, from, next) => {
    if (window.obelix.jwt) {
        console.debug('Access Token fourni');
        window.localStorage.setItem('feathers-jwt', window.obelix.jwt);
    }
    // Rediriger vers la racine si l'utilisateur n'a pas le rôle
    if (to.matched.some((record) => record.meta.restrictRoles)) {

        try {
            if (!window.localStorage.getItem('feathers-jwt')) {
                if (window.obelix.jwt) {
                    console.debug('Access Token fourni', window.obelix.jwt)
                    window.localStorage.setItem('feathers-jwt', window.obelix.jwt);
                }else{
                    console.log("Veuillez vous connecter");
                    next({ path: '/login' });
                    return;
                }
            }
            let user = store.getters['user']
            if (!user) {
                user = (await feathersClient.reAuthenticate()).user;
                if (!user) {
                    console.warn("Connexion automatique impossible, veuillez vous connecter manuellement");
                    next({ path: '/login' });
                    return;
                }
                await store.dispatch('setUser', user);
            }

            let rolesToHave = to.matched.find((record) => record.meta.restrictRoles).meta.restrictRoles;

            if (!user.role || rolesToHave.indexOf(user.role) == -1) {
                console.warn("Cette ressource est en accès protégé...");
                next({ path: '/' });
                return;
            }

        } catch(error) {
            await store.dispatch('setEditorError', error);
            next('/login');
        }
    }

    next(); // make sure to always call next()!
});


export default router;

